export const RevenueDashboardRoute = {
  path: '/dashboard',
  load: () => import('./RevenueDashboard'),
  protected: true,
};
